// extracted by mini-css-extract-plugin
export var deleteModal = "_et-0";